import { SettingsApi } from '@itsrever/rever-api'
import { apiClient } from '@/infrastructure/api'
import { EcommerceContact } from '@/domain/ecommerce-contact'
import { toApiContacts, toEcommerceContacts, unsupportedContacts } from './dto'

const settingsApi = new SettingsApi(undefined, undefined, apiClient)

async function getGroupContacts(ecommerceGroup: string, signal?: AbortSignal) {
  const response = await settingsApi.findGroupContacts(
    { ecommerceGroup },
    { signal }
  )
  return toEcommerceContacts(response.data.contacts ?? [])
}

// The API replaces every contact of the group, so this reads right before writing and
// carries over the contacts whose type the dashboard does not know. Skips the write when
// update returns undefined.
async function updateGroupContacts(
  ecommerceGroup: string,
  update: (contacts: EcommerceContact[]) => EcommerceContact[] | undefined
) {
  const response = await settingsApi.findGroupContacts({ ecommerceGroup })
  const stored = response.data.contacts ?? []
  const next = update(toEcommerceContacts(stored))
  if (!next) return
  await settingsApi.saveGroupContacts({
    pbSaveGroupContactsRequest: {
      ecommerce_group: ecommerceGroup,
      contacts: [...toApiContacts(next), ...unsupportedContacts(stored)]
    }
  })
}

export default {
  getGroupContacts,
  updateGroupContacts
}
